<template>
  <div id="app" v-if="userData != ''" style=" min-width: 100%; margin-top:0">
    <v-app>
      <v-main
        style="position:fixed; top:0;padding-top:60px; min-width: 100%; min-height: -webkit-fill-available;"
      >
        <!-- <v-content style=" top:0;padding-top:60px; min-width: 100%; min-height: -webkit-fill-available;" > -->

        <CatchAlert />
        <Navbar v-if="projectsLoaded == true"/>
        <router-view  v-if="projectsLoaded == true"/>

      </v-main>
    </v-app>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import CatchAlert from "@/components/CatchAlert.vue";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "App",
  components: {
    Navbar,
    CatchAlert
  },
  computed: {
    ...mapState(["userData","projectsLoaded"]),
    ...mapState("app", ["isEditing", "showRightMenu"])
  },
  methods: {
    ...mapActions(["loginUser"]),
    ...mapMutations("app", [
      "setIsEditing",
      "closeRightMenuMutation",
      "openRightMenuMutation"
    ]),
    ...mapMutations("locations", [
    "disableRightMenuMutation",
    "activeRightMenuMutation"
    ]),
    ...mapMutations("devices", [
    "closeAllRightMenuDevicesMutation",
    ])
  },
  watch: {
    $route(to, from) {
      // Utilizamos keepRightMenu para mantenerlo visible al cambiar desde tablas a zonas
     if (this.keepRightMenu == true) {
        // if (from.name == "DevicesListTableBySite" && to.name == "BigSizeZone") {
          this.setIsEditing(true);
          this.openRightMenuMutation();
        // }
        this.disableRightMenuMutation()
      } else {
        
        if (
          (from.name == "DevicesListTable" && to.name == "BigSizeZone") ||
          // (from.name == "AllDevicesListTable" && to.name == "BigSizeZone") ||
          (from.name == "BigSizeZone" && to.name == "BigSizeZone")
        ) {
          this.setIsEditing(true);
          this.openRightMenuMutation();

        } else if (this.showRightMenu) {
          this.closeAllRightMenuDevicesMutation()
          this.closeRightMenuMutation();
          this.setIsEditing(false);
        }
      }
      // Evitamos que se muestre el menú si cambiamos de una primera vez de la vista tabla general de devices a mapa de una zona
      // if (from.name == "AllDevicesListTable" && to.name == "BigSizeZone") {
      //   this.closeRightMenuMutation();
      //   this.setIsEditing(false);
      // }
    }
  },
  created() {
    this.loginUser();
  }
};
</script>

<style>
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  padding-top: -64px;
  padding-left: 0;
  padding-right: 0;
}

/* Fix Vuetify row margin issue */
.row {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue